var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg-icon',{staticClass:"tip-text",attrs:{"name":"tip","size":_vm.size},nativeOn:{"click":function($event){return _vm.confirmTip.apply(null, arguments)}}})}
var staticRenderFns = []

export { render, staticRenderFns }